import { autoinject, transient } from "aurelia-framework";
import { RightShipOnboardingQuestionCommentService } from "../../../../services/rightship-onboarding/rightship-onboarding-question-comment.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipDialogServiceConstants } from "../../../../constants/basics/rightship-dialog.constants";
import { DeleteMessageConfirmationModel } from "../../../../models/workflow/workflow.models";

@autoinject()
@transient()
export class QuestionMessagesView {

    constructor(public questionCommentsService: RightShipOnboardingQuestionCommentService, private dialogClientService: DialogClientService) { }

    //Edit message
    public editMessage(msg: any) {
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.AddMessageDialog, { item: msg }, true, false)
    }

    //Delete message
    public deleteMessage(msg: any) {
        const model = new DeleteMessageConfirmationModel();
        model.question = msg.question;
        model.message = msg.comment;
        model.onDelete = () => {            
            this.questionCommentsService.removeQuestionComment(msg.guid);
        }

        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.DeleteMessageConfirmationDialog, model, true, false)
    }

}